import login from '../../models/login';
import axios from 'axios';
import qs from 'qs';
import { END_POINTS } from '..';

export const loginApi  = (params: login.LoginRequest) =>{
    let url = END_POINTS.login;
	return axios.post(url, qs.stringify(params)).then((res: { data: login.LoginResponse }) => res.data);
}
